export default __webpack_public_path__ + "static/media/chart.4671d708.svg";